import { AgentDef } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { AgentDefForm } from "./AgentDefForm";


export const AgentDefEditable = function (
    props: EditableProps<AgentDef>
) {

    return (
        <DataFormWithButtonsLayout editableProps={props}>
            <AgentDefForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
